
import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { SectionHeading } from '../App';

const FAQItem: React.FC<{ question: string; answer: string }> = ({
  question,
  answer,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="py-4">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full py-4 flex justify-between items-center text-left gap-4 group focus:outline-none"
      >
        <span className="text-base md:text-lg font-bold text-slate-900 group-hover:text-[#ee1d23] transition-colors">
          {question}
        </span>
        <div
          className={`shrink-0 transition-transform duration-300 ${isOpen ? "rotate-180 text-[#ee1d23]" : "text-slate-400"}`}
        >
          <ChevronDown size={20} />
        </div>
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? "max-h-96 pb-4 opacity-100" : "max-h-0 opacity-0"}`}
      >
        <p className="text-sm md:text-base leading-relaxed text-slate-600">
          {answer}
        </p>
      </div>
    </div>
  );
};

const Pertanyaan: React.FC = () => {
  const faqs = [
    {
      question: "Apakah Hisana Fried Chicken sudah bersertifikat Halal?",
      answer:
        "Ya, Hisana Fried Chicken telah memiliki sertifikat Halal dari MUI (Halal Indonesia) untuk seluruh proses produksinya, mulai dari penyembelihan hingga penyajian.",
    },
    {
      question: "Berapa minimal order untuk layanan delivery?",
      answer:
        "Minimal order untuk layanan antar (delivery) langsung ke alamat adalah Rp 50.000 (tidak termasuk ongkos kirim) untuk area jangkauan outlet terdekat.",
    },
    {
      question: "Apakah bisa memesan untuk acara pesta atau syukuran?",
      answer:
        "Tentu bisa! Kami melayani pesanan partai besar (Paket Box) untuk berbagai acara. Silahkan hubungi WhatsApp admin kami minimal H-1 untuk koordinasi.",
    },
    {
      question: "Bagaimana cara melakukan pembayaran pesanan?",
      answer:
        "Kami menerima pembayaran tunai (Cash on Delivery), Transfer Bank (BSI), dan juga pembayaran digital melalui QRIS (Gopay, OVO, ShopeePay).",
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 max-w-4xl">
        <SectionHeading
          title="Pertanyaan Umum"
          subtitle="Beberapa hal yang sering ditanyakan pelanggan kami."
        />
        <div className="bg-white rounded-[2.5rem] p-8 md:p-12 border border-slate-100">
          <div className="divide-y divide-slate-100">
            {faqs.map((faq, idx) => (
              <div
                key={idx}
                className="border-b transition-all border-slate-200"
              >
                <FAQItem question={faq.question} answer={faq.answer} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pertanyaan;
